<template>
  <div class="container my-4">
    <div class="component-header mb-4">
      <h1>Budynek</h1>
      <div class="ml-4 add-edit-actions">
        <button type="submit" form="building-pictures" class="action">
          <i class="fa fa-floppy-o" aria-hidden="true"></i>
        </button>
        <button data-toggle="modal" data-target="#buildingPic" class="action">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div
        class="saved-text"
        v-bind:class="[
          showMessage ? 'visible' : 'hidden',
          success ? 'text-success' : 'text-danger',
        ]"
      >
        {{ messageText }}
      </div>
    </div>
    <form id="building-pictures" @submit.prevent="save()">

      <div class="form-group">
        <label for="card-image2">Zdjęcia</label>
        <building-image
          v-for="image in images"
          v-bind:key="image.id"
          v-bind:image="image"
          @remove-image="removeImage(image)"
          @up-image="upImage(image)"
          @down-image="downImage(image)"
        >
        </building-image>
        <div
          id="my-strictly-unique-vue-upload-multiple-image"
          style="display: flex; justify-content: center"
        >
          <vue-upload-multiple-image
            @upload-success="uploadImageSuccess"
            :data-images="controlImages"
            :maxImage="25"
            style="z-index: 1"
            width="500"
            height="500"
            margin="16"
            dragText="Przeciągnij obrazki"
            browseText="Wyszukaj obrazki"
            idUpload="myIdUpload"
            editUpload="myIdEdit"
          >
          </vue-upload-multiple-image>
        </div>
      </div>
    </form>
    <Modal v-bind:settings="modalSettings" @confirm="goBack()" />
    <Loader v-if="showLoader" />
  </div>
</template>

<script>
import Modal from "./Modal";
import FileReader from "vue-filereader";
import BuildingImage from "./Image";
import PictureInput from "vue-picture-input";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import Loader from "./Loader";

export default {
  components: {
    Modal,
    BuildingImage,
    //PictureInput,
    VueUploadMultipleImage,
    Loader,
  },
  props: ["list"],
  data() {
    return {
      images: [],
      modalSettings: {
        body: "Czy na pewno chcesz wyjść? Niezapisane zmiany zostaną utracone.",
        modalId: "buildingPic",
      },
      messageText: "",
      showMessage: false,
      controlImages: [],
      id: null,
      success: false,
      showLoader: false,
    };
  },
  methods: {
    initialize: function () {
      this.id = this.$route.params.id;
        if (this.id) {
          this.$api.getBuildingImagesById(this.id).then((data) => {
            this.images = data;
          });
        }
    },
    addImage: function () {
      let maxId =
        this.images && this.images.length
          ? this.images.reduce(
              (max, image) => (image.id > max ? image.id : max),
              this.images[0].id
            )
          : 0;
      let image = {
        descriptionPL: "",
        descriptionDE: "",
        id: maxId + 1,
        name: "",
        imageData: null,
        buildingId: this.id
      };
      this.images.push(image);
      return image;
    },
    uploadImageSuccess(formData, index, fileList) {
      let image = this.addImage();
      image.imageData = fileList[index].path;
      image.name = fileList[index].name;
      if (index === fileList.length - 1) {
        this.controlImages.splice(0);
      }
    },
    removeImage(image) {
      var index = this.images.indexOf(image);
      if (index > -1) {
        this.images.splice(index, 1);
      }
    },
    upImage(image) {
      var index = this.images.indexOf(image);
      if (index > 0) {
        this.images.splice(index -1, 0, this.images.splice(index, 1)[0]);
      }
    },
    downImage(image) {
      var index = this.images.indexOf(image);
      if (index >= 0 && index < this.images.length -1) {
        this.images.splice(index + 1, 0, this.images.splice(index, 1)[0]);
      }
    },
    save: function () {
      this.clearMessage();
      this.update(this.images);
    },
    update: function (data) {
      this.$api.updateBuildingImages(data).then((response) => {
        if (response.ok) {
          this.displaySucess();
        } else {
          this.displayFailure();
        }
      });
    },
    createBase64Image(fileObject) {
      const reader = new window.FileReader();
      let self = this;
      reader.onloadend = function (event) {
        try {
          let res = event.target.result;
          self.imageData = res;
        } catch (err) {
          alert("Error: " + err);
        }
      };
      reader.readAsDataURL(fileObject);
    },
    onChange() {
      console.log("Picture changed!");
      if (this.$refs.pictureInput.file) {
        this.createBase64Image(this.$refs.pictureInput.file);
      } else {
        console.log("Old browser. No support for Filereader API");
      }
    },
    displaySucess: function () {
      this.messageText = "Dane zostały pomyślnie zapisane";
      this.showMessage = true;
      this.success = true;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayFailure: function () {
      this.messageText = "Wystąpił błąd w zapisie danych";
      this.showMessage = true;
      this.success = false;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayNonUniqueValue: function () {
      this.messageText =
        "Nie można zapisać zdjęcia. Zdjęcie o tej nazwie już istnieje.";
      this.showMessage = true;
      this.success = false;
    },
    clearMessage() {
      this.messageText = "";
      this.showMessage = false;
    },
    goBack() {
      this.$router.push({ name: "BuildingDetails" });
    },
    goBackWithSave() {
      this.save();
      this.goBack();
    },
  },
  created() {
    this.initialize();
  },
  beforeRouteUpdate(to, from, next) {
    this.initialize();
    next();
  },
};
</script>

<style>
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>